import { gsap, MotionPathPlugin } from 'gsap/all';
import { useEffect } from 'react';

/**
 * For when we have an object that should follow a path. Tied to the user's scroll position.
 * @param {*} props
 * @returns
 */

function Key4({ animate }) {
   gsap.registerPlugin(MotionPathPlugin);

   useEffect(() => {
      const pathElem = document.querySelector('.key4');
      const offsetFromTop = window.innerHeight * 0.3;
      const pathBB = pathElem.getBoundingClientRect();
      const startY = pathBB.top + window.scrollY - offsetFromTop + 100;
      // const startY = document.querySelector("#path1").offsetTop - window.innerHeight + offsetFromTop;
      const finishDistance = 900;

      const tween = gsap.to('#key4', {
         duration: 50,
         paused: true,
         progress: animate ? 0.1 : 0.5,
         repeat: 0,
         reverse: true,
         keyframes: [
            {
               motionPath: {
                  path: '#fixedpath4',
                  align: '#fixedpath4',
                  alignOrigin: [0.1, 0.1],
                  autoRotate: 180,
                  start: 0.1,
               },
            },
            { opacity: 0 },
         ],
         ease: 'none',
      });

      let requestId = null;
      // document.addEventListener("scroll", handleScroll);

      if (animate) {
         document.addEventListener('scroll', handleScroll);
         tween.progress((window.scrollY - startY) / finishDistance);
      } else {
         document.removeEventListener('scroll', handleScroll);
         tween.progress(0.5);
      }

      function handleScroll() {
         if (!requestId) {
            requestId = requestAnimationFrame(update);
         }
      }

      function update() {
         // Update our animation

         if (animate) {
            tween.progress((window.scrollY - startY) / finishDistance);
         } else {
            tween.progress(0.5);
         }
         // Let the scroll event fire again
         requestId = null;
      }
      return () => document.removeEventListener('scroll', handleScroll);
   }, [animate]);
   return (
      <div className="pathcontainer key4-container">
         <svg
            className="key4"
            xmlns="http://www.w3.org/2000/svg"
            width="550.368"
            height="396.92"
         >
            <image
               id="key4"
               href="/ReactAssets/CustomerJourney/keypaths/desktop/Key.svg"
               width="80"
               height="80"
               data-svg-origin="24 12"
               transform="matrix(0.19357,-0.98109,0.98109,0.19357,536.52035,85.57834)"
            />
            <path
               transform="rotate(-83 3423.76 5305.68)"
               stroke-dasharray="10 14"
               stroke-width="2"
               stroke-linejoin="round"
               stroke-linecap="round"
               stroke="#a29064"
               fill="none"
               d="m7942.05903,1302.9012c289.573,121.582 21.727,431.726 334.373,510.612"
               data-name="Path 4"
               id="path4"
            />
            <path
               fill="none"
               d="M 550.054 61.037 C 515.743 179.74 424.729 226.691 264.011 208.392 C 145.395 194.887 57.303 235.624 -0.722 334.439"
               id="fixedpath4"
            />
         </svg>
      </div>
   );
}

export default Key4;
